import { render, staticRenderFns } from "./koptionaltext.vue?vue&type=template&id=01b5c8bb&scoped=true"
import script from "./koptionaltext.vue?vue&type=script&lang=js"
export * from "./koptionaltext.vue?vue&type=script&lang=js"
import style0 from "./koptionaltext.vue?vue&type=style&index=0&id=01b5c8bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5c8bb",
  null
  
)

export default component.exports